/* Fragrans Göteborg – Rituals-stil: pilar för produktkaruseller och sidfotens dragspel på mobil. */
(function () {
  function initRails(root) {
    root.querySelectorAll('.fg-products').forEach(function (sec) {
      var rail = sec.querySelector('[data-fg-rail]');
      var arrows = sec.querySelector('[data-fg-arrows]');
      if (!rail || !arrows || rail.dataset.fgReady) return;
      rail.dataset.fgReady = '1';
      var prev = arrows.querySelector('[data-dir="-1"]');
      var next = arrows.querySelector('[data-dir="1"]');
      function update() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
        arrows.hidden = max <= 0;
      }
      arrows.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-dir]');
        if (!b) return;
        var item = rail.querySelector('.fg-rail__item');
        var step = item ? item.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: step * Number(b.dataset.dir), behavior: 'smooth' });
      });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initFooter() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('.fg-footer__col[open]').forEach(function (d) { d.removeAttribute('open'); });
  }

  function init() { initRails(document); initFooter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { initRails(e.target); });
})();


/* 2026-10-25: tabeller i artiklar, sidor och kategoribeskrivningar får en rullningsbar ram,
   så att en bred tabell aldrig gör hela sidan bredare än skärmen (mobilen blev vit vid utzoomning). */
(function () {
  function wrapTables() {
    document.querySelectorAll('.fg-prose table, .rte table').forEach(function (t) {
      var p = t.parentElement;
      if (!p || p.classList.contains('fg-table-scroll')) return;
      if (p.style && /auto|scroll/.test(p.style.overflowX)) { p.classList.add('fg-table-scroll'); return; }
      var w = document.createElement('div');
      w.className = 'fg-table-scroll';
      p.insertBefore(w, t);
      w.appendChild(t);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wrapTables);
  else wrapTables();
})();